/**
 * Custom navigation for product gallery in thumbnail_slider layout
 * Handles arrow button clicks to switch between product images
 */
(function() {
  'use strict';

  function initProductGalleryNavigation() {
    console.log('[Product Gallery Navigation] Initializing...');
    const mediaGalleries = document.querySelectorAll('media-gallery[data-desktop-layout*="thumbnail"]');
    console.log('[Product Gallery Navigation] Found media galleries:', mediaGalleries.length);
    
    mediaGalleries.forEach((mediaGallery, index) => {
      console.log(`[Product Gallery Navigation] Processing gallery ${index + 1}`);
      const viewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
      const thumbnails = mediaGallery.querySelector('[id^="GalleryThumbnails"]');
      
      console.log('[Product Gallery Navigation] Viewer:', viewer ? 'Found' : 'Not found');
      console.log('[Product Gallery Navigation] Thumbnails:', thumbnails ? 'Found' : 'Not found');
      
      if (!viewer || !thumbnails) {
        console.warn('[Product Gallery Navigation] Missing viewer or thumbnails, skipping');
        return;
      }

      // The viewer IS the slider-component (id="GalleryViewer-...")
      // So we use viewer directly - no need to search for it
      const mainSlider = viewer;
      console.log('[Product Gallery Navigation] Viewer is the main slider');
      console.log('[Product Gallery Navigation] Viewer tagName:', viewer.tagName);
      console.log('[Product Gallery Navigation] Viewer id:', viewer.id);

      // Try multiple selectors to find buttons - search in viewer and its children
      let prevButton = viewer.querySelector('button[name="previous"]');
      let nextButton = viewer.querySelector('button[name="next"]');
      
      console.log('[Product Gallery Navigation] Buttons found in viewer:', {
        prev: prevButton ? 'Found' : 'Not found',
        next: nextButton ? 'Found' : 'Not found'
      });
      
      // If not found, try finding in slider-buttons container
      if (!prevButton || !nextButton) {
        const sliderButtons = viewer.querySelector('.slider-buttons');
        console.log('[Product Gallery Navigation] Slider buttons container:', sliderButtons ? 'Found' : 'Not found');
        if (sliderButtons) {
          prevButton = sliderButtons.querySelector('button[name="previous"]') || sliderButtons.querySelector('.slider-button--prev');
          nextButton = sliderButtons.querySelector('button[name="next"]') || sliderButtons.querySelector('.slider-button--next');
          console.log('[Product Gallery Navigation] Buttons found in slider-buttons:', {
            prev: prevButton ? 'Found' : 'Not found',
            next: nextButton ? 'Found' : 'Not found'
          });
        }
      }
      
      // Try finding by class in viewer
      if (!prevButton || !nextButton) {
        prevButton = viewer.querySelector('.slider-button--prev');
        nextButton = viewer.querySelector('.slider-button--next');
        console.log('[Product Gallery Navigation] Buttons found by class:', {
          prev: prevButton ? 'Found' : 'Not found',
          next: nextButton ? 'Found' : 'Not found'
        });
      }
      
      // Last resort: search in mainSlider if it's different from viewer
      if ((!prevButton || !nextButton) && mainSlider && mainSlider !== viewer) {
        prevButton = mainSlider.querySelector('button[name="previous"]') || mainSlider.querySelector('.slider-button--prev');
        nextButton = mainSlider.querySelector('button[name="next"]') || mainSlider.querySelector('.slider-button--next');
      }

      console.log('[Product Gallery Navigation] Prev button:', prevButton);
      console.log('[Product Gallery Navigation] Next button:', nextButton);
      console.log('[Product Gallery Navigation] Prev button found:', prevButton ? 'Yes' : 'No');
      console.log('[Product Gallery Navigation] Next button found:', nextButton ? 'Yes' : 'No');
      
      if (prevButton) {
        console.log('[Product Gallery Navigation] Prev button details:', {
          tagName: prevButton.tagName,
          name: prevButton.name,
          className: prevButton.className,
          id: prevButton.id
        });
      }
      
      if (nextButton) {
        console.log('[Product Gallery Navigation] Next button details:', {
          tagName: nextButton.tagName,
          name: nextButton.name,
          className: nextButton.className,
          id: nextButton.id
        });
      }

      if (!prevButton || !nextButton) {
        console.warn('[Product Gallery Navigation] Buttons not found, listing all buttons in mainSlider:');
        const allButtons = mainSlider.querySelectorAll('button');
        console.log('[Product Gallery Navigation] Total buttons found:', allButtons.length);
        allButtons.forEach((btn, idx) => {
          console.log(`[Product Gallery Navigation] Button ${idx}:`, {
            name: btn.name,
            className: btn.className,
            text: btn.textContent.trim()
          });
        });
        return;
      }

      // Get all media items
      const mediaItems = Array.from(viewer.querySelectorAll('[data-media-id]'));
      console.log('[Product Gallery Navigation] Media items found:', mediaItems.length);

      if (mediaItems.length === 0) {
        console.warn('[Product Gallery Navigation] No media items found, skipping');
        return;
      }

      // Function to switch to next/previous media
      function switchMedia(direction) {
        console.log(`[Product Gallery Navigation] switchMedia called with direction: ${direction}`);

        const thumbItems = Array.from(thumbnails.querySelectorAll('[data-target]'));
        if (!thumbItems.length) {
          console.warn('[Product Gallery Navigation] No thumbnails found');
          return;
        }

        const currentActive = viewer.querySelector('[data-media-id].is-active') || mediaItems[0];
        const currentMediaId = currentActive?.getAttribute('data-media-id') || '';
        const currentNumeric = (currentMediaId.match(/(\d+)$/) || [])[1];
        let currentIndex = thumbItems.findIndex(t => t.dataset.target === currentMediaId);
        if (currentIndex === -1 && currentNumeric) {
          currentIndex = thumbItems.findIndex(t => (t.dataset.target || '').endsWith(currentNumeric));
        }
        if (currentIndex === -1) currentIndex = 0;
        console.log('[Product Gallery Navigation] Current thumb index:', currentIndex, 'mediaId:', currentMediaId);

        const delta = direction === 'next' ? 1 : -1;
        const nextIndex = (currentIndex + delta + thumbItems.length) % thumbItems.length;
        const nextThumbnail = thumbItems[nextIndex];
        const mediaId = nextThumbnail?.dataset.target;
        if (!mediaId) {
          console.error('[Product Gallery Navigation] Next mediaId missing');
          return;
        }
        console.log('[Product Gallery Navigation] Next thumb index:', nextIndex, 'mediaId:', mediaId);

        // 调用 Shopify 原生切换
        try {
          if (mediaGallery.setActiveMedia) {
            mediaGallery.setActiveMedia(mediaId, false);
          }
        } catch (e) {
          console.warn('[Product Gallery Navigation] setActiveMedia failed:', e);
          // Fallback DOM
          mediaItems.forEach(item => item.classList.remove('is-active'));
          const fallbackMedia = mediaItems.find(m => (m.getAttribute('data-media-id') || '').includes(mediaId)) || mediaItems[nextIndex] || mediaItems[0];
          fallbackMedia.classList.add('is-active');
        }

        // 同步缩略图状态并点击触发原生行为
        if (nextThumbnail) {
          const thumbButton = nextThumbnail.querySelector('button');
          const allThumbButtons = thumbnails.querySelectorAll('button[data-target]');
          allThumbButtons.forEach(btn => btn.removeAttribute('aria-current'));
          if (thumbButton) {
            thumbButton.setAttribute('aria-current', 'true');
            thumbButton.click();
          }
        }

        // 滚动缩略图可见
        setTimeout(() => {
          const scrollThumbnail = nextThumbnail || thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (scrollThumbnail) {
            const thumbnailList = thumbnails.querySelector('.thumbnail-list.slider--tablet-up');
            if (thumbnailList) {
              const thumbnailTop = scrollThumbnail.offsetTop;
              const thumbnailHeight = scrollThumbnail.offsetHeight;
              const containerHeight = thumbnailList.clientHeight;
              const scrollTop = thumbnailList.scrollTop;
              const thumbnailBottom = thumbnailTop + thumbnailHeight;
              const visibleTop = scrollTop;
              const visibleBottom = scrollTop + containerHeight;
              
              if (thumbnailTop < visibleTop) {
                thumbnailList.scrollTo({ top: thumbnailTop - 20, behavior: 'smooth' });
              } else if (thumbnailBottom > visibleBottom) {
                thumbnailList.scrollTo({ top: thumbnailTop - containerHeight + thumbnailHeight + 20, behavior: 'smooth' });
              }
            }
          }
        }, 50);
      }

      // 确保按钮可点击（有些场景会被 slider-component 置为 disabled）
      prevButton.removeAttribute('disabled');
      nextButton.removeAttribute('disabled');

      // Attach lightweight listeners WITHOUT replacing Shopify默认监听，保留原生滑动逻辑
      console.log('[Product Gallery Navigation] Attaching lightweight listeners (no cloning)...');
      try {
        prevButton.addEventListener('click', function() {
          console.log('[Product Gallery Navigation] Prev button clicked');
          switchMedia('prev');
        }, { passive: true });
        
        nextButton.addEventListener('click', function() {
          console.log('[Product Gallery Navigation] Next button clicked');
          switchMedia('next');
        }, { passive: true });
        
        console.log('[Product Gallery Navigation] Lightweight listeners attached');
      } catch (error) {
        console.error('[Product Gallery Navigation] Error attaching listeners:', error);
      }
      
      // Test if buttons are clickable
      console.log('[Product Gallery Navigation] Testing button clickability...');
      console.log('[Product Gallery Navigation] Prev button disabled:', prevButton.disabled);
      console.log('[Product Gallery Navigation] Next button disabled:', nextButton.disabled);
      console.log('[Product Gallery Navigation] Prev button pointer-events:', window.getComputedStyle(prevButton).pointerEvents);
      console.log('[Product Gallery Navigation] Next button pointer-events:', window.getComputedStyle(nextButton).pointerEvents);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGalleryNavigation);
  } else {
    initProductGalleryNavigation();
  }

  // Re-initialize when new content is loaded (e.g., variant changes)
  document.addEventListener('shopify:section:load', initProductGalleryNavigation);
})();

